import React from 'react'
import { BOTTOM_HERO_IMAGE } from '../helpers/constants'
import Button from './MainButton'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='hero-image' data-style='bottom-hero'>
      <div data-type='overlay' />
      <picture data-type='image'>
        <img
          width='1440'
          height='454'
          itemProp='image'
          src={BOTTOM_HERO_IMAGE}
          alt='hero'
          role='presentation'
          data-type='image'
        />
      </picture>
      <h2>Sell your art to a global community of art lovers</h2>
      <Button dataStyle='hero-button' modalName='from-bottom-hero' />
    </div>
  )
}

export default Component